import { Modal } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { del, } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IOperacaoAgricola, IOperacaoTrabalhadorSchema } from "../../Interfaces/atividade/atividade";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { Modaladdtrabalhadors } from "./add_trabalhador";
import { ITrabalhador } from "../../Interfaces/maoobra/maoobra";
import { Modalvertrabalhadors } from "./ver_trabalhador";

interface I_aux {
    list: IOperacaoTrabalhadorSchema[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list: React.Dispatch<React.SetStateAction<IOperacaoTrabalhadorSchema[]>>,
    obj_atividade: IOperacaoAgricola | undefined,
    list_aux: ITrabalhador[],
    set_obj_new_atividade: React.Dispatch<React.SetStateAction<IOperacaoAgricola | undefined>>,

}

export const Modalverlistatrabalhador: React.FC<I_aux> = ({
    list,
    list_aux,
    flag_open_modal,
    set_flag_open_modal,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list,
    obj_atividade,
    set_obj_new_atividade,
}) => {
    const auth = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes_trabalhadors, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_trabalhadors] = useState<boolean>(false);

    const [flag_open_modal_ver_mais, set_flag_open_modal_ver_mais] = useState<boolean>(false);
    const [flag_open_modal_edit, set_flag_open_modal_edit] = useState<boolean>(false);
    const [flag_open_modal_add, set_flag_open_modal_add] = useState<boolean>(false);
    const [flag_open_modal_aux, set_flag_open_modal_aux] = useState<boolean>(false);
    const [obj_new, set_obj_new] = useState<IOperacaoTrabalhadorSchema>();

    const [hover, setHover] = useState<{ flag: boolean; id: number | null }>({ flag: false, id: null });


    useEffect(() => {
        (async () => {
            set_list(obj_atividade?.trabalhadores ?? [])
        })();
    }, []);

    const handle_delete_trabalhadors = async () => {

        try {
            setIsLoading(true);
            await del(auth.token.cookie_token, `/api/operacoes/trabalhadores/${obj_new?.id_op_trab}`);
            list.splice(list.findIndex((trabalhador) => trabalhador.id_op_trab === obj_new?.id_op_trab), 1);

            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_trabalhadors(false)
            setMessage(operacao_sucesso);
            setOpenSnackSuccess(true);
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_trabalhadors", error, true);
            setIsLoading(false);
            if ((error as any)?.response?.data?.message) {
                setMessage((error as any).response.data.message);
            } else {
                setMessage(operacao_erro);
            }
            setOpenSnackError(true);
        }
    };


    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    Detalhes da Atividade

                </h2>
                <button
                    type="button"
                    onClick={() => {
                        set_flag_open_modal(false)
                        set_flag_open_modal_ver_mais(false)
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>


            {
                flag_open_modal_aux === true &&
                <Modaladdtrabalhadors
                    list={list}
                    flag_open_modal={flag_open_modal_aux}
                    set_flag_open_modal={set_flag_open_modal_aux}
                    setMessage={setMessage}
                    setOpenSnackSuccess={setOpenSnackSuccess}
                    setOpenSnackError={setOpenSnackError}
                    set_list={set_list}
                    flag_open_modal_ver_mais={flag_open_modal_ver_mais}
                    set_flag_open_modal_ver_mais={set_flag_open_modal_ver_mais}
                    flag_open_modal_edit={flag_open_modal_edit}
                    set_flag_open_modal_edit={set_flag_open_modal_edit}
                    flag_open_modal_add={flag_open_modal_add}
                    set_flag_open_modal_add={set_flag_open_modal_add}
                    set_obj_new={set_obj_new}
                    obj_new={obj_new}
                    obj_atividade={obj_atividade}
                    lista_de_trabalhadores_aux={list_aux}
                    set_obj_new_atividade={set_obj_new_atividade}

                />
            }
            {
                flag_open_modal_ver_mais === true &&
                <Modalvertrabalhadors
                    list={list}
                    flag_open_modal={flag_open_modal_aux}
                    set_flag_open_modal={set_flag_open_modal_aux}
                    setMessage={setMessage}
                    setOpenSnackSuccess={setOpenSnackSuccess}
                    setOpenSnackError={setOpenSnackError}
                    set_list={set_list}
                    flag_open_modal_ver_mais={flag_open_modal_ver_mais}
                    set_flag_open_modal_ver_mais={set_flag_open_modal_ver_mais}
                    set_obj_new={set_obj_new}
                    obj_new={obj_new}
                    obj_atividade={obj_atividade}
                    lista_de_trabalhadores_aux={list_aux}

                />
            }

            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col w-full flex-1 overflow-auto">
                            <div className="w-full p-5 flex justify-start">

                                <button
                                    type="button"
                                    onClick={() => {
                                        set_flag_open_modal_aux(true)
                                        set_flag_open_modal_edit(true)
                                        set_flag_open_modal_add(true)
                                        set_obj_new(undefined)
                                    }}
                                    className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                >
                                    <AddIcon sx={{ fontSize: 18 }} />
                                    Adicionar Registo de Trabalhadores
                                </button>
                            </div>
                            <div className="flex flex-col w-full flex-1 overflow-auto px-5 pb-5">

                                {
                                    list.length > 0 ?
                                        <div className="w-full mt-4">
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Registos de Trabalhadores</div>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">



                                                {list.map((trabalhadors, index) => {
                                                    const isSelected = obj_new?.id_op_trab === trabalhadors.id_op_trab;
                                                    const isHovered = hover.flag && hover.id === trabalhadors.id_op_trab;

                                                    return (
                                                        <div
                                                            key={index}
                                                            className={`
                                                            flex flex-col items-center justify-center w-[180px] min-w-[180px] w-full max-w-[250px] p-4 rounded-xl cursor-pointer
                                                            transition-all duration-200
                                                            ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                                                            ${isHovered ? 'shadow-md' : 'shadow-sm'}
                                                          `}
                                                            onMouseEnter={() => setHover({ flag: true, id: trabalhadors.id_op_trab })}
                                                            onMouseLeave={() => setHover({ flag: false, id: trabalhadors.id_op_trab })}

                                                        // onClick={() => {
                                                        //     set_flag_open_modal_aux(true)
                                                        //     set_obj_new(trabalhadors)
                                                        //     set_flag_open_modal_ver_mais(true)
                                                        //     set_flag_open_modal_edit(false)
                                                        //     set_flag_open_modal_add(false)
                                                        // }}

                                                        >
                                                            <div className="space-y-2 text-sm">
                                                                <div className="flex items-center justify-between gap-3">
                                                                    <span className="text-gray-500">Horas</span>
                                                                    <span className="text-gray-800 font-medium truncate">
                                                                        {trabalhadors.horas || '-'}
                                                                    </span>
                                                                </div>
                                                                <div className="flex items-center justify-between gap-3">
                                                                    <span className="text-gray-500">Custo por Hora</span>
                                                                    <span className="text-gray-800 font-medium truncate">
                                                                        {trabalhadors.custo_hora || '-'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="flex justify-between gap-2 mt-4">

                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        set_obj_new(trabalhadors);
                                                                        set_flag_open_modal_aux(true);
                                                                        set_flag_open_modal_ver_mais(true);
                                                                        set_flag_open_modal_edit(false);
                                                                        set_flag_open_modal_add(false);
                                                                    }}
                                                                    className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                                                >
                                                                    <VisibilityIcon sx={{ fontSize: 18 }} />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        set_obj_new(trabalhadors);
                                                                        set_flag_open_modal_aux(true);
                                                                        set_flag_open_modal_edit(true);
                                                                        set_flag_open_modal_add(false);

                                                                    }}
                                                                    className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                                                >
                                                                    <EditIcon sx={{ fontSize: 18 }} />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_trabalhadors(true)
                                                                        set_obj_new(trabalhadors)

                                                                    }}
                                                                    className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                                                >
                                                                    <DeleteIcon sx={{ fontSize: 18 }} />
                                                                </button>
                                                            </div>
                                                          
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div> : null
                                }

                            </div>




                        </div>
                    </>
            }

            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes_trabalhadors}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_trabalhadors(false)}
                onConfirm={() => handle_delete_trabalhadors()}
                message={'Deseja eliminar o registo?'}

            />

        </div>



    </Modal>)

}
